// extracted by mini-css-extract-plugin
export default {"wrapper":"date-picker_wrapper__3dsGN","input":"date-picker_input__OU26D"};